import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ArrowLeft",
  "use": "ArrowLeft-usage",
  "viewBox": "0 0 12 20",
  "content": "<symbol viewBox=\"0 0 12 20\" id=\"ArrowLeft\"><path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M12 16.646L5.544 10 12 3.354 9.228.5 0 10l9.228 9.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol